// extracted by mini-css-extract-plugin
module.exports = {"footer":"AppLayout_footer__piRpV","homeHeader":"AppLayout_homeHeader__5iKkD"};